import type { ReactNode } from 'react';

import { MAIL_CONTENT_KINDS, TEMPLATE_TYPES } from 'cpool-constants';
import type { SchemaUserResolver_Get } from 'cpool-tables/backend-resolvers';
import DOMPurify from 'dompurify';

import { useOwnMailHeaderFooter } from './hooks/useOwnMailHeaderFooter';
import { formatEtaHeaderFooterSignatureContent } from './utils/formatEtaHeaderFooterSignatureContent';
import type { InputKind } from '../headerFooterTemplate/types';

type Props = {
    contentKind: InputKind;
    user: SchemaUserResolver_Get | undefined;
};

export const Footer: React.FC<Props> = ({ contentKind, user }) => {
    const { data } = useOwnMailHeaderFooter();
    const footer = data?.footer ?? null;
    const convertedFooterContent: string | Array<ReactNode> = formatEtaHeaderFooterSignatureContent({
        contentKind,
        mailContent: footer && { data: footer, type: TEMPLATE_TYPES.MAIL_FOOTER },
        user,
    });

    if (contentKind === MAIL_CONTENT_KINDS.MAIL_CONTENT && footer?.mailContent) {
        return <div>{convertedFooterContent}</div>;
    }
    if (contentKind === MAIL_CONTENT_KINDS.MAIL_HTML_CONTENT && convertedFooterContent) {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(convertedFooterContent as string, {
                        ADD_TAGS: ['style'],
                    }),
                }}
            />
        );
    }
    return null;
};
